import { FC } from "react";
import "./PageTitle.scss"

type Props = {
    text: string
}

const PageTitle: FC<Props> = ({ text }) => {
    return (
        <h1 className="page_title">
            {text}
        </h1>
    )
}

export default PageTitle